import React, { createContext, useContext, useState, useMemo } from 'react';
import Meta from '@/types/components/MansionNavigation/Meta';

type MetaContextType = {
  meta: Meta;
  setMeta: React.Dispatch<React.SetStateAction<Meta>>;
};

const MetaContext = createContext<MetaContextType | undefined>(undefined);

export function useMeta(): MetaContextType {
  const context = useContext(MetaContext);
  if (!context) {
    throw new Error('useMeta must be used within a MetaProvider');
  }
  return context;
}

type MetaProviderProps = {
  initialMeta: Meta;
  children: React.ReactNode;
};

export function MetaProvider(props: MetaProviderProps): React.JSX.Element {
  const { initialMeta, children } = props;
  const [meta, setMeta] = useState<Meta>(initialMeta);
  const memoMeta = useMemo(() => ({ meta, setMeta }), [meta, setMeta]);

  return <MetaContext.Provider value={memoMeta}>{children}</MetaContext.Provider>;
}

export default MetaProvider;
